<div class="alerts-page">

  <div class="alerts-header">
    <div class="alerts-header-left">
      <h2 class="alerts-title">Alerts</h2>
    </div>
  </div>

  <div class="alerts-card">
    <app-alerts-list />
  </div>

</div>
